export default "__VITE_ASSET__cfb03102__"